import type { ResourceLandingPage } from './types';

export const fallbackResourcePage: ResourceLandingPage = {
  id: 'fallback-landing',
  slug: 'resources',
  heroEyebrow: 'Contentful Demo',
  title: 'Contentful Resources Showcase',
  subtitle:
    'Connect your Contentful space to see real data. This mock payload mirrors the content model defined in the migration.',
  helperText: 'Run pnpm contentful:migrate and add entries in Contentful.',
  primaryCtaLabel: 'Open Contentful',
  primaryCtaUrl: 'https://app.contentful.com/',
  secondaryCtaLabel: 'View Migration',
  secondaryCtaUrl: 'https://github.com/contentful/contentful-migration',
  lastUpdated: new Date().toISOString(),
  featuredResources: [
    {
      id: 'mock-astro',
      slug: 'astro-ui-kit',
      name: 'Astro UI Kit',
      summary: 'Composable components for rapidly prototyping Astro projects.',
      url: 'https://astro.build/themes',
      resourceType: 'template',
      difficulty: 'intermediate',
      tags: ['astro', 'starter', 'design'],
      highlighted: true,
      metrics: {
        label: 'Downloads',
        value: '12.4k',
        helper: 'Past 30 days',
      },
      logoUrl: 'https://astro.build/social-card.jpg',
      categoryId: 'mock-accelerators',
    },
    {
      id: 'mock-zapier',
      slug: 'zapier-contentful',
      name: 'Zapier + Contentful',
      summary:
        'Automate editorial workflows with Zapier triggers targeting Contentful.',
      url: 'https://zapier.com/apps/contentful/integrations',
      resourceType: 'api',
      difficulty: 'beginner',
      tags: ['automation', 'ops'],
      highlighted: true,
      metrics: {
        label: 'Automations',
        value: '350+',
      },
      categoryId: 'mock-integrations',
    },
  ],
  resources: [
    {
      id: 'mock-nextra',
      slug: 'nextra-docs',
      name: 'Nextra Docs Theme',
      summary: 'Opinionated docs framework powered by Next.js and MDX.',
      url: 'https://nextra.site/',
      resourceType: 'template',
      difficulty: 'intermediate',
      tags: ['docs', 'nextjs'],
      ctaLabel: 'View GitHub',
      ctaUrl: 'https://github.com/shuding/nextra',
      metrics: { label: 'GitHub Stars', value: '11k+' },
      categoryId: 'mock-accelerators',
    },
    {
      id: 'mock-formbricks',
      slug: 'formbricks',
      name: 'Formbricks',
      summary:
        'Open source product research suite with Contentful webhooks integration.',
      url: 'https://formbricks.com/integrations/contentful',
      resourceType: 'tool',
      difficulty: 'beginner',
      tags: ['research', 'automation'],
      categoryId: 'mock-integrations',
    },
    {
      id: 'mock-edgesse',
      slug: 'edgesse',
      name: 'Edgesse Headless Commerce',
      summary:
        'Composable commerce starter blending Contentful, Stripe, and Next.js.',
      url: 'https://www.edgesse.com/',
      resourceType: 'template',
      difficulty: 'advanced',
      tags: ['commerce', 'nextjs'],
      metrics: { label: 'Time to launch', value: '2 weeks' },
      categoryId: 'mock-accelerators',
    },
    {
      id: 'mock-lottie',
      slug: 'lottiefiles',
      name: 'LottieFiles animations',
      summary:
        'Drop-in micro-interactions you can reference from Contentful assets.',
      url: 'https://lottiefiles.com/',
      resourceType: 'tool',
      difficulty: 'beginner',
      tags: ['animation', 'motion'],
      categoryId: 'mock-experience',
    },
  ],
  categories: [
    {
      id: 'mock-accelerators',
      slug: 'accelerators',
      title: 'Launch Accelerators',
      summary: 'Templates and starter kits that help teams ship faster.',
      icon: 'Zap',
      themeColor: 'from-purple-500/20 to-purple-700/10',
      weight: 0,
    },
    {
      id: 'mock-integrations',
      slug: 'integrations',
      title: 'Integrations',
      summary: 'Connect Contentful to the rest of your stack.',
      icon: 'Link',
      themeColor: 'from-emerald-500/20 to-emerald-700/10',
      weight: 1,
    },
    {
      id: 'mock-experience',
      slug: 'experience',
      title: 'Experience Enhancers',
      summary: 'Delightful add-ons for UX teams.',
      icon: 'Sparkles',
      themeColor: 'from-amber-500/20 to-amber-700/10',
      weight: 2,
    },
  ],
  filterGroups: [
    {
      id: 'type-filter',
      title: 'Resource type',
      field: 'resourceType',
      options: ['tool', 'template', 'api'],
    },
    {
      id: 'level-filter',
      title: 'Level',
      field: 'difficulty',
      options: ['beginner', 'intermediate', 'advanced'],
    },
  ],
};
